/* 
  ck scrollTracker
  Show/hide ck header & advanced search tab, during scrolling in mobile view.
  Auto-hides tooltips on scroll.
  This code is totally self-contained module, with no public interface.
  This code is very tightly coupled to existing ck dom structure.
 */
$(function () {

  let headerHeight = $('#header').height();
  let $sidecartContainer = $('#sidecartContainer');
  let $body = $('body');
  let $headerSearch = $('.headerSearch');
  let $ckTooltip = $('.ckTooltip');
  let sidecartPaddingTop = parseInt($sidecartContainer.css('padding-top'));
  let hideMenuClass = 'hiddenMenu';
  let _lastScrollY = 0;

  /* Adjust sidecart max-height as footer appears */
  let _adjustSidecartHeight = function(){
    let scrollY = (window.scrollY || document.documentElement.scrollTop);
    let viewableContentHeight = $(window).height();
    let sidecartMaxHeight = viewableContentHeight;
    let footerTracker = $(document).height() - scrollY - $('.footer').outerHeight();
    let footerEclipse = viewableContentHeight - footerTracker;
    if (footerEclipse > 0) {
      sidecartMaxHeight = viewableContentHeight - footerEclipse - sidecartPaddingTop;
    }
    $sidecartContainer.css({'max-height': sidecartMaxHeight});
  };

  /* adjust header and sidecart position and height based on scroll position and footer */
  let _debouncedScroll = _.throttle(function () {
    let _scrollY = (window.scrollY || document.documentElement.scrollTop);//ie fix

    /* clear ckToolTips */
    if (ck.showHelp === true) {
      $ckTooltip.css({'display': 'none'});
      ck.showHelp = false;
    }

    /* show/hide header & advancedMenu */
    if ($(window).outerWidth() > 1200) {
      $body.removeClass(hideMenuClass);
      _adjustSidecartHeight();
    } else {
      if (_lastScrollY !== 0) {
        if (_scrollY < _lastScrollY) {
          $body.removeClass(hideMenuClass);
        } else {
          if (_scrollY > headerHeight) {
            $body.addClass(hideMenuClass);
            $headerSearch.removeClass('showSearch');
          }

        }
      }
      _lastScrollY = (window.scrollY || document.documentElement.scrollTop);
    }

  }, 50); //throttle scroll handler to 50ms to not overwhelm browser but to keep it enough fast to avoid visual issues. 

  $(document).on('scroll', function () {
    _debouncedScroll();
  });

  _debouncedScroll(); //init

  $(document).on('cartUpdated.ck',function(){
    $body.removeClass(hideMenuClass);
  });

});
